export const GENAI_DISCLOSURE_OPTIONS = [
    {label: 'No GenAI', value: 'None'},
    {label: 'Partly GenAI', value: 'Partly'},
    {label: 'Fully GenAI', value: 'All'},
    {label: 'Unknown', value: 'Unknown'},
];

export const GENAI_DISCLOSURE_TOOLTIP =
    'Required before a YouTube delivery. Pitch correction and AI mastering count as No GenAI. Unknown sends the track with no declaration and YouTube may label it. Fully GenAI leaves the YouTube subscription pool and can still earn from ads.';

export const GENAI_FULLY_ALERT =
    "Fully GenAI tracks are excluded from YouTube's subscription revenue pool. They can still earn from ads.";
